module.exports = __webpack_public_path__ + "static/media/boldblue.ab6358bc.png";